import { render, staticRenderFns } from "./CandidateRedirectRoute.vue?vue&type=template&id=453d45d7&scoped=true"
import script from "./CandidateRedirectRoute.vue?vue&type=script&lang=ts"
export * from "./CandidateRedirectRoute.vue?vue&type=script&lang=ts"
import style0 from "./CandidateRedirectRoute.vue?vue&type=style&index=0&id=453d45d7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453d45d7",
  null
  
)

export default component.exports